import React from 'react';

const dayNames = ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'];

function AvailabilityBlock({ availabilities }) {
  const grouped = {};

  availabilities.forEach(av => {
    const day = dayNames[av.day_of_week];
    if (!grouped[day]) grouped[day] = [];
    grouped[day].push(`${av.start_time} - ${av.end_time || 'fin inconnue'}`);
  });

  return (
    <div style={{ backgroundColor: '#f5f0e1', padding: '15px', borderRadius: '10px', maxWidth: '300px' }}>
      <h4>🕐 Disponibilités :</h4>
      {Object.entries(grouped).map(([day, slots]) => (
        <p key={day}><strong>{day}:</strong> {slots.join(' / ')}</p>
      ))}
    </div>
  );
}

export default AvailabilityBlock;